import { render } from "./OwnerProfileViewLink.vue?vue&type=template&id=2b4b25b3&ts=true"
import script from "./OwnerProfileViewLink.vue?vue&type=script&lang=ts"
export * from "./OwnerProfileViewLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__